// extracted by mini-css-extract-plugin
module.exports = {"ContactContainer":"kontakt-module--ContactContainer--HiP9p"};